import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import OwlCarousel from "react-owl-carousel";
import React from "react";

interface OwlCarouselSlider1Props {
    children?: React.ReactNode;
}
export const OwlCarouselSlider1 = (props:OwlCarouselSlider1Props) => {

    return (
        <OwlCarousel className="owl-theme" loop margin={30} nav responsive={{
            0:{
                margin:10,
                items:1
            },
            769:{
                margin:20,
                items:1
            },
            1281:{
                items:1
            }
        }}>
            {props.children}
        </OwlCarousel>
    )
}

export const OwlCarouselSlider2 = (props:OwlCarouselSlider1Props) => {

    return (
        <OwlCarousel className={'nv_site_list owl-theme'} loop={false} margin={30} nav={false} mouseDrag={false} responsive={{
            0:{
                margin:10,
                items:1
            },
            768:{
                items:2,
                margin:20
            },
            1024:{
                items:3,
                margin:20
            },
            1280:{
                items:5
            }
        }}>
            {props.children}
        </OwlCarousel>
    )
}

export const OwlCarouselSlider3 = (props:OwlCarouselSlider1Props) => {

    return (
        <OwlCarousel loop={false} margin={0} nav={true} responsive={{
            0:{
                items:1
            }
        }}>
            {props.children}
        </OwlCarousel>
    )
}
